<template>
  <div class="material-card">
    <div class="header"><span>素材管理</span></div>
    <el-container class="container">
      <el-aside class="asider-style">
        <material-folder @saveFolderDetail="saveFolderDetail"></material-folder>
      </el-aside>

      <el-main class="card-main">
        <material-filter @saveFilterParams="saveFilterParams"></material-filter>
        <material-list
          @getFiles="getFiles"
          :materialList="materialList"
          :loading="loading"
          @updateTable="updateTable"
          :folderId="folder.id"
          @sendSelectOption="sendSelectOption"
        ></material-list>
        <div style="text-align: right; margin-top: 16px">
          <el-pagination
            background
            @current-change="currentChange"
            layout="total,sizes,prev, pager, next"
            :page-sizes="[10, 20, 50]"
            :total="count"
            :page-size="param.pageSize"
            :current-page="param.pageIndex"
            @size-change="sizeChange"
          >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import MaterialFolder from "./materialFolder.vue";
import MaterialList from "./materialList.vue";
import { getFilesFetch } from "../../api/material";
import MaterialFilter from "./materialFilter.vue";
export default {
  name: "MaterialManagement",
  components: { MaterialFolder, MaterialList, MaterialFilter },
  data() {
    return {
      folder: {
        id: null,
      },
      materialList: [],
      loading: false,
      count: 0,
      param: {
        key: null, //关键字
        resolution: [], // 分辨率
        direction: [], //素材 版型
        designer: [], //设计师
        tag: [],
        type: "全部", // video image
        pageSize: 10,
        pageIndex: 1,
        demander: [],
        creativeSource: [],
      },
    };
  },

  methods: {
    saveFolderDetail(data) {
      this.folder = data;
      this.getFiles(data);
    },
    saveFilterParams(data) {
      this.param = { ...data };
      this.getFiles(this.folder);
    },
    getFiles(data) {
      this.loading = true;
      let tempParam = {
        ...this.param,
        resolution: this.param.resolution.join(","), // 分辨率
        direction: this.param.direction.join(","), //素材 版型
        designer: this.param.designer.join(","), //设计师
        tag: this.param.tag.join(","),
        type: this.param.type == "全部" ? "" : this.param.type == "视频" ? "video" : "image",
        demander: this.param.demander.join(","),
        // creativeSource: this.param.creativeSource.join(","),
      };
      getFilesFetch({ folderId: data.id, ...tempParam })
        .then((res) => {
          this.materialList = res.list;
          this.loading = false;
          this.count = Number(res.count);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    updateTable(folderId) {
      this.getFiles(folderId);
    },
    currentChange(page) {
      this.param.pageIndex = page;
      this.getFiles(this.folder);
    },
    sizeChange(size) {
      this.param.pageSize = size;
      this.getFiles(this.folder);
    },
    sendSelectOption(list) {
      this.$emit("getFilesList", list);
    },
  },
};
</script>
<style lang="less">
.material-card {
  border-radius: 4px;
  margin: 16px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.15);
  height: calc(~"100% - 42px");
  background: #ffffff;
  .container {
    height: calc(~"100% - 48px");
    width: 100%;
  }
  .header {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    color: rgba(24, 144, 255, 1);
    padding-left: 25px;
  }
  .asider-style {
    width: 280px !important;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
  }
  .card-main {
    padding: 16px 24px;
    width: calc(100% - 200px);
    position: relative;
  }
}
</style>
